export default __webpack_public_path__ + "static/Microsoft-hackathon-c1a5b349e207042205da7f032e126740.jpeg";